import axios from "axios";
import { blueprintsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";

export const getMyBlueprintLibrary = async (namespace: string) => {
  try {
    const url = blueprintsUrlEnvVar();
    const res = await axios.get(
      `${url}/api/v3/ns/${namespace}/blueprints/my-blueprint-library`,
      {
        headers: buildAxiosAuthenticationHeaders(),
        // Keep non-2xx responses in normal flow so callers can branch on status/body.
        validateStatus: () => true,
      },
    );

    return {
      status: res.status,
      body: res.data,
    };
  } catch (err) {
    navigateTo(Route.SERVER_ERROR);
  }
};
